var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-subscription-quota"},[_c('Tabs',{staticClass:"c-tabs c-tabs--standard"},[_c('Tab',{attrs:{"Title":_vm.$t( 'SUBSCRIPTION_QUOTA' )}},[_c('QuotaLines',{attrs:{"Record":_vm.Record}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }